import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

export const filtersInitialState: Filter[] = [
  { name: 'overviewDetails.roles', label: 'Officer Role Type', value: [] },
  { name: 'IncomeTaxInvestigations', label: 'Tax Office: Income Tax Civil', value: [] },
]
